var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useMemo, useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { eligibilitySteps } from '../../../common/eligibilityQuestions';
import PolicyFormInput from '../../../common/PolicyFormInput';
import PolicyStepsHeader from '../../../common/PolicyStepsHeader';
import PolicyFormProgressBar from '../../../common/PolicyFormProgressBar';
import api from '../../../../api';
import useWidgetStore, { CurrentTabEnum } from '../../../../stores/widgetStore';
import { createValidationSchema } from '../../../common/Form/validations';
import useConfigStore from '../../../../stores/configStore';
var styles = {
    container: 'flex flex-col w-full h-full bg-white',
    content: 'px-6 py-4 flex-1 overflow-y-auto custom-scrollbar text-left',
    group: 'flex flex-col gap-4 mb-6 xl:max-w-[50%]',
    loadingContainer: 'flex w-full h-full items-center justify-center'
};
var EligibilityForm = function () {
    var _a = useWidgetStore(), setCurrentTab = _a.setCurrentTab, setEligibilityEngineAnswers = _a.setEligibilityEngineAnswers, eligibilityEngineAnswers = _a.eligibilityEngineAnswers;
    var formTheme = useConfigStore().style.formTheme;
    var _b = useState(0), currentStepIndex = _b[0], setCurrentStepIndex = _b[1];
    var _c = useState(null), lookupData = _c[0], setLookupData = _c[1];
    var _d = useState(true), isLoading = _d[0], setIsLoading = _d[1];
    var _e = useState(Yup.object()), validationSchema = _e[0], setValidationSchema = _e[1];
    var currentStep = eligibilitySteps[currentStepIndex];
    var isLastStep = currentStepIndex === eligibilitySteps.length - 1;
    useEffect(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        setIsLoading(true);
                        return [4 /*yield*/, api.quote.getBrizaStatesClassCodes()];
                    case 1:
                        response = _b.sent();
                        if ((_a = response.data) === null || _a === void 0 ? void 0 : _a.data) {
                            setLookupData(response.data.data);
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _b.sent();
                        console.error('Failed to fetch eligibility lookups:', error_1);
                        return [3 /*break*/, 4];
                    case 3:
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, []);
    var stateOptions = useMemo(function () {
        if (!(lookupData === null || lookupData === void 0 ? void 0 : lookupData.productAvailability))
            return [];
        return Object.keys(lookupData.productAvailability)
            .sort()
            .map(function (code) { return ({ value: code, caption: code }); });
    }, [lookupData]);
    var formik = useFormik({
        initialValues: (eligibilityEngineAnswers === null || eligibilityEngineAnswers === void 0 ? void 0 : eligibilityEngineAnswers.answers) || {},
        validationSchema: validationSchema,
        validateOnMount: false,
        validateOnChange: false,
        validateOnBlur: false,
        onSubmit: function (values) {
            var _a, _b;
            if (isLastStep) {
                var productAvailability = (lookupData === null || lookupData === void 0 ? void 0 : lookupData.productAvailability) || {};
                var availableProducts = (_b = (_a = productAvailability[values.State]) === null || _a === void 0 ? void 0 : _a[values.ClassCode]) === null || _b === void 0 ? void 0 : _b.map(function (v) {
                    return v == 'eo' ? 'PL' : v == 'cyber' ? 'Cyber' : v.toUpperCase();
                });
                console.log('Final Submission Data:', values, availableProducts);
                setEligibilityEngineAnswers({ answers: values, availableProducts: availableProducts });
                setCurrentTab(CurrentTabEnum.ELIGIBLE_POLICIES);
            }
            else {
                setCurrentStepIndex(function (prev) { return prev + 1; });
                formik.setTouched({}, false);
            }
        }
    });
    var classCodeOptions = useMemo(function () {
        var selectedState = formik.values['State'];
        var allClassDetails = (lookupData === null || lookupData === void 0 ? void 0 : lookupData.classCodeToDetails) || [];
        var productAvailability = (lookupData === null || lookupData === void 0 ? void 0 : lookupData.productAvailability) || {};
        if (!selectedState) {
            return allClassDetails;
        }
        var stateData = productAvailability[selectedState];
        if (!stateData)
            return [];
        var validCodes = Object.keys(stateData);
        return allClassDetails.filter(function (item) { return validCodes.includes(item.value); });
    }, [formik.values['State'], lookupData]);
    useEffect(function () {
        var questionsWithOptions = currentStep.questions.map(function (q) {
            var qCopy = __assign({}, q);
            if (q.questionKey === 'State') {
                qCopy.options = stateOptions;
            }
            else if (q.questionKey === 'ClassCode') {
                qCopy.options = classCodeOptions;
            }
            return qCopy;
        });
        var schema = createValidationSchema({
            questions: questionsWithOptions,
            removedQuestions: [],
            values: formik.values,
            tempValues: formik.values,
            groupKey: currentStep.stepId
        });
        setValidationSchema(schema);
    }, [
        JSON.stringify(currentStep),
        JSON.stringify(formik.values),
        stateOptions,
        classCodeOptions,
    ]);
    useEffect(function () {
        if (!isLoading) {
            var currentClassCode_1 = formik.values['ClassCode'];
            if (currentClassCode_1) {
                var isValidOption = classCodeOptions.some(function (opt) { return opt.value === currentClassCode_1; });
                if (!isValidOption) {
                    formik.setFieldValue('ClassCode', '', false);
                }
            }
        }
    }, [formik.values['State'], classCodeOptions, isLoading]);
    var handleNextClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var stepErrors, currentStepKeys, hasStepError, touchedFields;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, formik.validateForm()];
                case 1:
                    stepErrors = _a.sent();
                    currentStepKeys = currentStep.questions.map(function (q) { return q.questionKey; });
                    hasStepError = Object.keys(stepErrors).some(function (key) {
                        return currentStepKeys.includes(key);
                    });
                    if (hasStepError) {
                        touchedFields = currentStepKeys.reduce(function (acc, key) {
                            var _a;
                            return (__assign(__assign({}, acc), (_a = {}, _a[key] = true, _a)));
                        }, {});
                        formik.setTouched(touchedFields);
                        formik.setFormikState(function (prevState) { return (__assign(__assign({}, prevState), { validateOnChange: true })); });
                    }
                    else {
                        formik.submitForm();
                        formik.setFormikState(function (prevState) { return (__assign(__assign({}, prevState), { validateOnChange: false })); });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleBack = function () {
        if (currentStepIndex > 0) {
            setCurrentStepIndex(function (prev) { return prev - 1; });
            formik.setErrors({});
            formik.setTouched({}, false);
        }
    };
    var steps = eligibilitySteps.map(function (step, index) { return ({
        stepText: step.title,
        isStepActive: index === currentStepIndex,
        isStepCompleted: index < currentStepIndex
    }); });
    if (isLoading && currentStepIndex === 1) {
        return (React.createElement("div", { className: styles.loadingContainer },
            React.createElement("span", { className: "text-[#1F2751] font-bold text-lg" }, "Loading...")));
    }
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: "sticky top-0 z-10 bg-white shadow-sm" },
            React.createElement(PolicyStepsHeader, { theme: formTheme, steps: steps, nextButtonText: 'Next', backButtonText: "Back", isBackDisabled: currentStepIndex === 0, handleBack: handleBack, handleNext: handleNextClick }),
            React.createElement("div", { className: "flex flex-col bg-white z-0 w-full py-4 px-6" },
                React.createElement(PolicyFormProgressBar, { steps: steps.length, activeStep: currentStepIndex + 1 }),
                React.createElement("h2", { className: "capitalize text-2xl text-[#1F2751] font-bold mt-3 text-center" }, currentStep.title))),
        React.createElement("div", { className: styles.content },
            React.createElement("div", { className: styles.group }, currentStep.questions.map(function (q) {
                var options = undefined;
                if (q.questionKey === 'State')
                    options = stateOptions;
                if (q.questionKey === 'ClassCode')
                    options = classCodeOptions;
                return (React.createElement(PolicyFormInput, { key: q.questionKey, label: q.question, question: q, questionKey: q.questionKey, inputType: q.inputType, value: formik.values[q.questionKey], handleChange: formik.handleChange(q.questionKey) || (function () { }), handleChangeAutocomplete: function (val) {
                        return formik.setFieldValue(q.questionKey, val);
                    }, handleBlur: formik.handleBlur, options: options, errors: formik.errors[q.questionKey], touched: formik.touched[q.questionKey], helper: 'helper' in q ? q.helper : undefined, isDisabled: !lookupData &&
                        (q.questionKey === 'State' || q.questionKey === 'ClassCode'), dataField: q.questionKey }));
            })))));
};
export default EligibilityForm;
